/* template */
<template><OrderCommonCard hideDivider class="card-wrapper" v-if="(discountTickets.length)"><mpx-image slot="title" mode="widthFix" src="https://ut-static.udache.com/webx/sfc/vr49hqRopzmoZ_99ZcARY_clipboard_image_1700210282723.png" class="title"/><div class="container"><mpx-view v-for="(item, index) in (discountTickets)" :key="item.index" @tap="onToDetail(item, index)" class="item"><div class="f-c-b"><div class="station"><div :class="({overflow:item.depOverflow})" class="station-name">{{item.depCityName}}</div><mpx-image mode="widthFix" src="https://ut-static.udache.com/webx/sfc/iOS1MTlo8b6uWBWbFruwB.png" class="icon"/><div :class="({overflow:item.arrOverflow})" class="station-name">{{item.arrCityName}}</div></div><div class="price">{{item.price}}</div></div><div class="f-e-b"><div class="date">{{item.date}}</div><div v-show="(item.discount)" class="discount">{{item.discount}}</div></div></mpx-view></div></OrderCommonCard></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m106bbc36"}'>
.card-wrapper
  border-radius 16px
.title
  width 64px
.container
  display flex
  flex-wrap wrap
  justify-content space-between
  font-size 12px
  line-height 1
  .item
    width calc(50% - 4px)
    height 62px
    padding 12px 8px
    box-sizing border-box
    border 1px solid #eeeeee
    border-radius 10px
    display flex
    flex-direction column
    justify-content space-between
    white-space nowrap
    margin-bottom 8px
    font-size 12px
    &:nth-last-child(-n+2)
      margin-bottom 0
    .f-c-b
      display flex
      align-items center
      justify-content space-between
    .f-e-b
      display flex
      align-items flex-end
      justify-content space-between
    .station
      font-size 14px
      color #333
      font-family PingFangSC-Medium
      font-weight 500
      line-height 18px
      display flex
      align-items center
      flex-shrink 1
      overflow hidden
      &-name
        flex none
        &.overflow
          flex-shrink 1
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
      .icon
        flex none
        width 10px
        margin 0 4px
    .price
      font-family Barlow Semi Condensed
      font-weight 500
      font-size 18px
      color #FF6400
      flex none
      display flex
      align-items center
      &::before
        content '¥'
        font-family PingFang SC
        font-size 16px
        font-weight 500
        transform translateY(1px) translateX(-1px)
    .date
      font-weight 400
      color #666
    .discount
      color #FF6400
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m106bbc36"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./special-ticket.mpx.js?isComponent&outputPath=components%2Fspecial-ticket106bbc36%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./special-ticket.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fspecial-ticket106bbc36%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m106bbc36"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/special-ticket106bbc36/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'OrderCommonCard':getComponent(require("../../../../components/order-common-card/index.mpx?isComponent&outputPath=components%2Findexc3d6ce32%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
